import { Link } from "wouter";
import { Card, CardContent } from "@/components/ui/card";
import { useBranding } from "@/hooks/use-branding";
import { Bot } from "lucide-react";
import AuthPanel from "@/components/auth-panel";

/**
 * /login (and /signup) route fallback for deep links (e.g. ?redirect=,
 * internal-org SSO via ?org=, or the /portal/staff redirect). The primary
 * entry point is the dialog on the landing page; this renders the same panel
 * centered on its own page.
 */
export default function LoginPage() {
  const branding = useBranding();
  const initialMode = typeof window !== "undefined" && window.location.pathname.startsWith("/signup") ? "signup" : "signin";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-sky-50 to-white px-4 py-10">
      <div className="absolute inset-x-0 top-0 -z-10 h-[360px] bg-[radial-gradient(ellipse_at_top,_rgba(99,102,241,0.10),_transparent_60%)]" />
      {/* WCAG 1.3.1: page must have an h1; AuthPanel renders h2 ("Welcome back"). */}
      <h1 className="sr-only">{branding.shortName} — Sign in</h1>
      <div className="w-full max-w-md">
        <Link href="/" className="flex items-center justify-center gap-2 mb-6" data-testid="link-home">
          <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-cyan-500 grid place-items-center text-white shadow-sm">
            <Bot className="w-5 h-5" aria-hidden="true" />
          </span>
          <span className="font-semibold tracking-tight text-lg text-slate-900">{branding.shortName}</span>
        </Link>
        <Card className="border-slate-200 shadow-sm">
          <CardContent className="p-6">
            <AuthPanel key={initialMode} initialMode={initialMode} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
